import { manifest as kindManifest } from './sort-children-of.action.kind.js';
import { manifests as modalManifests } from './modal/manifests.js';

export const manifests = [kindManifest, ...modalManifests];
